import styled from 'styled-components';
import color from '../../../constants/color';
import MaterialUi from '../../../material-UI';

export const MenuItem = styled(MaterialUi.MenuItem)`
  color: ${color.grey9};
`;
export const Input = styled(MaterialUi.TextField)`

`;
export const Chip = styled(MaterialUi.Chip)`
  background-color: ${color.blue};
  color: ${color.white};
  font-size: 14px;
  text-transform: uppercase;
`;
